module.exports = __webpack_public_path__ + "img/module5.71800cb.png";